import { Component, OnInit, Input } from "@angular/core";
import { FormGroup, AbstractControl, Validators } from "@angular/forms";

import {
  MainConfig,
  FormToolsService,
  ColorValidator,
  LocaleDataService,
} from "@atenea-cms";
import { Category } from "../../categories/shared";
import { Serie } from "../../series/shared";
import { ProductFormService, Product } from "../shared";

@Component({
  selector: "product-detail-general",
  templateUrl: "./product-detail-general.component.html",
  styleUrls: ["./product-detail-general.component.scss"],
})
export class ProductDetailGeneralComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() categories: Array<Category> = [];
  @Input() series: Array<Serie> = [];
  @Input() parentProducts: Array<Product>;

  modelTypes: Array<any> = [
    { value: "none", label: "Ninguno" },
    { value: "color", label: "Color" },
    { value: "options", label: "Opciones" },
  ];

  constructor(
    public ft: FormToolsService,
    public mainConfig: MainConfig,
    private localeService: LocaleDataService
  ) {}

  ngOnInit(): void {
    this.checkChanges();
  }

  checkChanges(): void {
    const modelType: AbstractControl = this.form.get("modelType");

    modelType.valueChanges.subscribe(this.modelTypeChange.bind(this));
    this.modelTypeChange(modelType.value);
  }

  modelTypeChange(type: string): void {
    const primaryColor: AbstractControl = this.form.get("modelPrimaryColor");
    const secondaryColor: AbstractControl = this.form.get(
      "modelSecondaryColor"
    );
    const name: AbstractControl = this.form.get("modelOptionName");

    primaryColor.clearValidators();
    secondaryColor.clearValidators();
    name.clearValidators();

    switch (type) {
      case "color":
        primaryColor.setValidators([Validators.required, ColorValidator]);

        secondaryColor.setValidators([ColorValidator]);

        break;

      case "options":
        name.setValidators([Validators.required]);

        break;
    }

    primaryColor.updateValueAndValidity();
    secondaryColor.updateValueAndValidity();
    name.updateValueAndValidity();
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-detail-general/product-detail-general.component.ts